import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DeviceDetectorModule } from 'ngx-device-detector';

import { ButtonModule } from '../button/index';
import { CardModule } from '../card/index';
import { FormModule } from '../form/index';
import { GenericModule } from '../generic/index';
import { GridModule } from '../grid/index';
import { IconModule } from '../icon/index';
import { LoadingModule } from '../loading/index';
import { TryAgainModule } from '../try-again/index';

import { TemplateComponent } from './template.component';
import { BreadcrumbComponent } from './components/breadcrumb.component';
import { ActionBarComponent } from './components/action-bar.component';
import { FormBarComponent } from './components/form-bar.component';

import { BreadcrumbService } from './breadcrumb.service';

export { TemplateComponent, TemplateSizes, TemplateScrollRef, TemplateBreakPoint } from './template.component';
export { ActionBarComponent } from './components/action-bar.component';
export { BreadcrumbComponent } from './components/breadcrumb.component';
export { FormBarComponent } from './components/form-bar.component';

export { BreadcrumbService } from './breadcrumb.service';

export { TemplateSize, TemplateTheme } from './template.enum';

@NgModule({
  declarations: [
    TemplateComponent,
    BreadcrumbComponent,
    ActionBarComponent,
    FormBarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,

    DeviceDetectorModule.forRoot(),

    ButtonModule,
    CardModule,
    FormModule,
    GenericModule,
    GridModule,
    IconModule,
    LoadingModule,
    TryAgainModule
  ],
  exports: [
    TemplateComponent,
    BreadcrumbComponent,
    ActionBarComponent,
    FormBarComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    BreadcrumbService
  ]
})
export class TemplateModule { }
